import { render, staticRenderFns } from "./HelloWorldNew.vue?vue&type=template&id=580ae485&scoped=true&"
import script from "./HelloWorldNew.vue?vue&type=script&lang=js&"
export * from "./HelloWorldNew.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorldNew.vue?vue&type=style&index=0&id=580ae485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ae485",
  null
  
)

export default component.exports